module.exports = file => () => import('@/views/' + file + '.vue')



// WEBPACK FOOTER //
// C:/Users/xiaolan/Desktop/Android/Xrross-SOC-Frontend/E:/xrross/Android/Xrross-SOC-Frontend/src/router/import-staging.js